import React from 'react';
import { Redirect } from 'react-router-dom';
import AlertComponent from '../components/alertComponent';
import FormComponent from '../components/formComponent';

class UiLogin extends React.Component {

    static defaultProps = {
        title: "Login",
        labels: {
            site: "My Beautiful Site",
            user: "User",
            pwd: "Password"
        }
    };

    constructor(props) {
        super(props);

        this.loginService = props.services;

        /* State */
        this.state = {
            site: this.props.siteSelection[props.defaultSelection],
            username: '',
            password: 'Abinsula2020',
            placeholder: 'Abinsula2020',
            loggedIn: props.loggedIn,
            alert: {
                messageAlert: 'message',
                variantAlert: 'primary',
                showAlert: false,
            }
        }
    }

    componentDidMount = () => {
        let response = this.loginService.autoLogin();
        this.setState({loggedIn: response.loggedIn});
    }

    handleLoginSubmit = (values) => {
        return (this.loginService.login(values)
            .then(() => {
                let stateUpdate = values;
                stateUpdate.loggedIn = true;
                this.setState(stateUpdate);
            }
            ).catch(this.handleSubmitError)
        )
    }

    renderAlert = (message, variant) => {
        this.setState({ alert: { messageAlert: message, variantAlert: variant, showAlert: true } });
    };

    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };

    renderLogin = () => {
        const initialValues = this.props.apiKeyMode
            ? {
                site: this.state.site,
                apiKey: ''
            }
            : {
                site: this.state.site,
                username: this.state.username,
                password: this.state.password
            };

        const credentialInputs = this.props.apiKeyMode
            ? [
                {
                    key: 'apiKey',
                    type: 'password',
                    inputType: 'input',
                    label: this.props.labels.apiKey,
                    placeholder: this.props.apiKeyPlaceholder
                }
            ]
            : [
                {
                    key: 'username',
                    type: this.props.userType,
                    inputType: 'input',
                    placeholder: this.props.userPlaceholder,
                    label: this.props.labels.user,
                    value: this.state
                },
                {
                    key: 'password',
                    type: 'password',
                    inputType: 'input',
                    label: this.props.labels.pwd,
                    value: this.state
                }
            ];

        return (
            <div>
                <FormComponent
                    initialValues={initialValues}
                    validateFunc={() => { }}
                    submitFunc={this.handleLoginSubmit}
                    inputs={[
                        {
                            key: 'site',
                            type: 'select',
                            inputType: 'select',
                            label: this.props.labels.site,
                            options: this.props.siteSelection.map(element => {
                                return { value: element, label: element };
                            })
                        },
                        ...credentialInputs
                    ]}
                />
                <div className='p-5'/>
                <div className='p-5'/>
            </div>
        );
    }



    render() {
        let { showAlert, variantAlert, messageAlert } = this.state.alert;
        return (
            <div className="container center">

                {!!this.props.loggedIn && <Redirect to={this.props.nextRoute} />}

                <AlertComponent show={showAlert} variant={variantAlert} message={messageAlert} dismissFunc={() => {
                    this.setState({ alert: { showAlert: false } })
                }} />
                {this.renderLogin()}
            </div>
        )
    }


}


export default UiLogin;
